const {VUE_APP_API_BASE_URL} = process.env

const apiBaseUrl = VUE_APP_API_BASE_URL

export {apiBaseUrl}
